
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class CredenzialiGrid extends Serenity.EntityGrid<CredenzialiRow, any> {
        protected getColumnsKey() { return CredenzialiColumns.columnsKey; }
        protected getDialogType() { return CredenzialiDialog; }
        protected getIdProperty() { return CredenzialiRow.idProperty; }
        protected getInsertPermission() { return CredenzialiRow.insertPermission; }
        protected getLocalTextPrefix() { return CredenzialiRow.localTextPrefix; }
        protected getService() { return CredenzialiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}